import React from 'react';

const CityIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            d='M13.3332 6.66658C13.3332 9.99525 9.6405 13.4619 8.4005 14.5326C8.28499 14.6194 8.14437 14.6664 7.99984 14.6664C7.85531 14.6664 7.71469 14.6194 7.59917 14.5326C6.35917 13.4619 2.6665 9.99525 2.6665 6.66658C2.6665 5.2521 3.22841 3.89554 4.2286 2.89535C5.2288 1.89516 6.58535 1.33325 7.99984 1.33325C9.41433 1.33325 10.7709 1.89516 11.7711 2.89535C12.7713 3.89554 13.3332 5.2521 13.3332 6.66658Z'
            stroke='#00225F'
            strokeWidth='1.25'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.99984 8.66658C9.10441 8.66658 9.99984 7.77115 9.99984 6.66658C9.99984 5.56201 9.10441 4.66658 7.99984 4.66658C6.89527 4.66658 5.99984 5.56201 5.99984 6.66658C5.99984 7.77115 6.89527 8.66658 7.99984 8.66658Z'
            stroke='#00225F'
            strokeWidth='1.25'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { CityIcon };
